<template>
  <div>
    <transition-group name="langTrans" mode="out-in">
      <!-- --------------------- ENGLISH --------------------- -->
      <div v-if="english" key="english">
        <div id="wrapper">
          <!-- Main -->
          <section id="main" class="wrapper">
            <div class="inner">
              <h1 class="major">
                Art<span class="lastname lastnameNoBorder">folio</span>
              </h1>
              <span class="image fit">
                <iframe
                  :width="isMobile ? 300 : larger ? 1400 : 720"
                  :height="isMobile ? 168 : larger ? 787 : 405"
                  src="https://www.youtube.com/embed/CLyaxDFUH7U"
                  title="YouTube video player"
                  frameborder="0"
                  allowfullscreen
                ></iframe>
              </span>
              <p>
                I have a little hobby of taking pictures when I play, and I also
                wanted to discover VueJS and make a project with it, so I made
                this photo portfolio site, which uses the flickr api to retrieve
                images of all sizes and resolutions. The project is
                <a
                  href="https://github.com/Fraulk/ArtFolio"
                  target="_blank"
                  rel="noreferrer noopener nofollow"
                  >open source</a
                >. <br /><br />
                <a
                  href="https://artpholio.netlify.app/#/"
                  target="_blank"
                  rel="noreferrer noopener nofollow"
                  >Live Demo</a
                >
              </p>
            </div>
          </section>
        </div>
      </div>
      <!-- --------------------- FRENCH --------------------- -->
      <div v-if="!english" key="french">
        <div id="wrapper">
          <!-- Main -->
          <section id="main" class="wrapper">
            <div class="inner">
              <h1 class="major">
                Art<span class="lastname lastnameNoBorder">folio</span>
              </h1>
              <span class="image fit">
                <iframe
                  :width="isMobile ? 300 : larger ? 1400 : 720"
                  :height="isMobile ? 168 : larger ? 787 : 405"
                  src="https://www.youtube.com/embed/CLyaxDFUH7U"
                  title="YouTube video player"
                  frameborder="0"
                  allowfullscreen
                ></iframe>
              </span>
              <p>
                J'ai un petit hobby qui est de prendre des photo lorsque je
                joue, et j'avais également envie de découvrir VueJS et de de
                faire un projet avec, donc j'ai fait ce site portfolio pour
                photo, qui utilise l'api de flickr pour récupérer les images de
                toutes tailles et résolutions. Le projet est
                <a
                  href="https://github.com/Fraulk/ArtFolio"
                  target="_blank"
                  rel="noreferrer noopener nofollow"
                  >open source</a
                >. <br /><br />
                <a
                  href="https://artpholio.netlify.app/#/"
                  target="_blank"
                  rel="noreferrer noopener nofollow"
                  >Live Demo</a
                >
              </p>
            </div>
          </section>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  props: {
    larger: Boolean,
    english: Boolean,
    isMobile: Boolean,
  },
};
</script>